import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const TRANSFERTOOL_ADMIN_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.TRANSFER_TOOL_ADMIN}.**`,
  url: '/transfertool-admin',
  loadChildren: () =>
    import('@transfertool-admin/app/transfertool-admin.module').then((m) => m.TransfertoolAdminModule),
};

export const APP_STATES = [TRANSFERTOOL_ADMIN_MODULE_STATE];
